import React, { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';

import { rowActions as TEXT } from 'locales/en/transaction';
import {
  RefundPayment,
  SendReceipt,
  CancelPayment,
  CapturePayment,
} from 'pages/Transactions/Detail/buttons';
import { getTransactionById } from 'redux/slices/transaction';
import {
  STATUS_AUTHORIZED,
  STATUS_SETTLED,
  STATUS_REFUNDED,
  STATUS_PARTIALLY_REFUNDED,
} from 'pages/Transactions/helpers';

const TransactionActions = ({
  isOpen,
  onClickOpen,
  onClose,
  transaction,
  position,
}) => {
  const dispatch = useDispatch();

  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewItem = (
      <Link
        to={`/transactions/${transaction.id}`}
        onClick={() => dispatch(getTransactionById(transaction.id))}
        className={className}
      >
        {TEXT.view}
      </Link>
    );
    const sendReceipt = (
      <SendReceipt transaction={transaction} className={className} />
    );
    const refundPayment = (
      <RefundPayment transaction={transaction} className={className} />
    );
    const capturePayment = (
      <CapturePayment
        transaction={transaction}
        className={className}
        onClick={() => dispatch(getTransactionById(transaction.id))}
      />
    );
    const cancelPayment = (
      <CancelPayment transaction={transaction} className={className} />
    );
    const { status } = transaction;
    let options = [viewItem]; // valid for cancelled|refused|failed|expired
    if (
      status === STATUS_AUTHORIZED &&
      !transaction.is_being_captured &&
      !transaction.is_being_adjusted
    ) {
      options.push(cancelPayment, capturePayment);
    } else if (
      [STATUS_SETTLED, STATUS_PARTIALLY_REFUNDED].some(
        (item) => item === status
      )
    ) {
      options.push(refundPayment, sendReceipt);
    } else if (status === STATUS_REFUNDED) {
      options.push(sendReceipt);
    }

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

TransactionActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  transaction: PropTypes.shape({}),
};
TransactionActions.defaultProps = {
  position: 'bottom',
  transaction: {},
};

export default memo(TransactionActions);
